module.exports = __webpack_public_path__ + "static/media/WEBnegro_61.0f4110d4.png";